
export default class SuccessString {

    // forgot-password-dux success messages
    static SUCCESS_FORGOTPASSWORD_REQUESTPASSWORD = 'SUCCESS_FORGOTPASSWORD_REQUESTPASSWORD';

    // forgot-user-id-dux success messages
    static SUCCESS_FORGOTUSERID_REQUESTUSERNAME = 'SUCCESS_FORGOTUSERID_REQUESTUSERNAME';

    // contact-us-dux success messages
    static SUCCESS_CONTACT_US = 'SUCCESS_CONTACT_US';

    // reset-password-dux success messages
    static SUCCESS_RESET_PASSWORD = 'SUCCESS_RESET_PASSWORD';

    // profile-dux success messages
    static SUCCESS_PROFILE_CHANGEPASSWORD = 'SUCCESS_PROFILE_CHANGEPASSWORD';
    static SUCCESS_PROFILE_SETUSERLOCALE = 'SUCCESS_PROFILE_SETUSERLOCALE';

    // on-the-spot-dux messages
    static SUCCESS_OTS_REDEEM = 'SUCCESS_OTS_REDEEM';

    static getByType ( state, successType ) {
        return state.successData.successMessages
            .filter( success => success.successType === successType );
    }

}
